import type { MouseEvent } from "react";
import { UnstyledButton } from "@mantine/core";
import { IconBookmark } from "@tabler/icons-react";

const CARD_NAVY = "#04305c";

const BOOKMARK_BTN_STYLES = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 38,
  flexShrink: 0,
  borderRadius: 8,
  border: `1.5px solid ${CARD_NAVY}`,
  backgroundColor: CARD_NAVY,
  color: "#FFFFFF",
  transition: "all 0.2s ease",
} as const;

type EcosystemHeadShortlistBookmarkButtonProps = {
  isShortlisted: boolean;
  onClick: () => void | Promise<void>;
};

export default function EcosystemHeadShortlistBookmarkButton({
  isShortlisted,
  onClick,
}: EcosystemHeadShortlistBookmarkButtonProps) {
  const label = isShortlisted ? "Remove from shortlist" : "Add to shortlist";

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    void onClick();
  };

  return (
    <UnstyledButton
      type="button"
      aria-label={label}
      title={label}
      onPointerDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onClick={handleClick}
      style={BOOKMARK_BTN_STYLES}
    >
      <IconBookmark size={18} color="white" fill={isShortlisted ? "currentColor" : "none"} />
    </UnstyledButton>
  );
}
